import { Button, Slider, Typography } from "@mui/material";
import Colors from "../../../../global/Colors";

const Injuries = ({ label, data }) => {
  function renderColor(rating) {
    if (rating > 6 && rating < 9) {
      return Colors.yellow[400];
    }
    if (rating >= 9) {
      return Colors.red[500];
    }
    return Colors.green[400];
  }
  return (
    <>
      <Typography fontWeight="medium" mb={0.5}>
        {label}
      </Typography>
      {data.map(({ rating, location }) => {
        const color = renderColor(rating);
        return (
          <div key={location} className="w-full">
            <span className="w-full text-sm">
              <b>{location}:</b> {rating}/10
            </span>
            <div className="flex items-center w-full gap-4">
              <Slider
                sx={{ color }}
                min={0}
                max={10}
                value={rating}
                onChange={() => null}
              />
              <span>{rating}</span>
              <Button
                className="text-xs normal-case w-fit rounded-3xl"
                variant="contained"
              >
                Reset
              </Button>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Injuries;
